import Vue from 'vue'
import Vuex from 'vuex'
import tab from './tab'
import profession from './professions'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    tab,
    profession
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js